import { SearchInput } from "@tfg/ui"
import { noop } from "lodash"
import { useTranslation } from "react-i18next"

import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const CertificatesSearch = () => {
  const { t } = useTranslation("certificates")

  const { search, setSearch } = useCertificatesTableContext()

  return (
    <SearchInput
      autoFocus
      delay={500}
      maw={200}
      style={{ flexGrow: 1 }}
      inputValue={search}
      onChange={(value) => setSearch(value.toString())}
      onOpen={noop}
      placeholder={t("lists.placeholders.search")}
    />
  )
}
